// @flow
import * as React from 'react'
import CheckboxField from '../CheckboxField'

// Types
import type { Props } from '../CheckboxField'

export type { Props }

/**
 * Just a wrapper around CheckboxField that provides correct
 * type to it.
 * @param {Props} props
 */
const RadioField = (props: Props) => <CheckboxField {...props} type="radio" />
RadioField.defaultProps = CheckboxField.defaultProps

export default RadioField
